<template>
  <div class="blocked_simcard_devices card" v-if="Object.keys(blocked_simcard_devices).length > 0">
    <div class="response_table">
      <router-link :to="'/tariffication/blocked_simcard?&fid=' + device_fid" class="table_label pointer">
        {{ translate('device.blocked_simcard.title') }}
      </router-link>

      <table>
        <thead>
          <tr>
            <th scope="col">
              {{ translate('services.blocked_simcard.reason') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.mno') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.iccid') }}
            </th>
            <th scope="col">
              {{ translate('services.blocked_simcard.simcard') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(simcard, key) in blocked_simcard_devices"
            :key="key"
            class="simcard_item pointer"
            @click="get_blocked_simcard_info(simcard.id)"
          >
            <td :data-label="translate('services.blocked_simcard.reason')">
              {{ get_reason(simcard.reason) }}
            </td>
            <td :data-label="translate('services.blocked_simcard.mno')">
              {{ simcard.mno }}
            </td>
            <td :data-label="translate('services.blocked_simcard.iccid')">
              {{ simcard.iccid }}
            </td>
            <td :data-label="translate('services.blocked_simcard.simcard')">
              <span class="badge" :class="global_status_color(+simcard.simcard_status)">
                {{ translate(global_status_text(+simcard.simcard_status)) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import ShowBlockedSimCard from "@/views/Dashboard/General/Services/Tabs/BlockedSimcard/Modal/ShowBlockedSimCard.vue";

export default {
  name: "BlockedSimcardDevices",
  props: [
    "device_fid",
  ],
  data() {
    return {
      blocked_simcard_devices: []
    };
  },
  computed: {
    simcards() {
      return this.client_request ? this.client_request.simcards : [];
    },
  },
  watch:{
    device_fid(){
      this.get_blocked_simcard_devices()
    }
  },
  created(){
    this.get_blocked_simcard_devices()
  },

  methods: {
    get_blocked_simcard_info(blocked_sim_id){
      this.$http.v1.getTarifficationBlockedSimcardInfo(blocked_sim_id, (response) => {
        this.show_blocked_simcard(response.data)
      })
    },
    show_blocked_simcard(blocked_simcard) {
      let t = this.$createElement(ShowBlockedSimCard, {
        props: {
          blocked_simcard_info: blocked_simcard
        },
        on: {
          update: () => {
            this.$modal.hide('show_blocked_simcard')
            this.get_blocked_simcard_devices()
          },
          close: () => {
            this.$modal.hide('show_blocked_simcard')
          },
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800,
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'show_blocked_simcard'
      })
    },
    get_reason(reason_id){
      return reason_id ? this.$store.getters.getBlockedSimcardReason.find((reason) => {
        if (reason_id === reason.id){
          return reason
        }
      }).title : ""
    },
    get_blocked_simcard_devices(){
      this.$http.v1.getBlockedSimcardDevices(this.device_fid, (response) => {
        this.blocked_simcard_devices = response.data
      })
    }
  },
};
</script>
<style lang='scss' scoped>
.blocked_simcard_devices{
  padding: 10px;
  margin-bottom: 10px;
  font-size: inherit;

  .response_table{
    padding: 0;
    margin-bottom: 10px;
    .table_label{
      font-size: 14px;
      line-height: 120%;
      font-weight: bold;
      color: #66615b;
      margin-bottom: 10px;
    }
    tr{
      &:hover{
        background-color: #eaeaea;
      }
    }

    td {
      .badge {
        font-size: 10px;
      }
    }
  }
}


</style>
